import React from 'react';
import { useDispatch } from 'react-redux';
import { insertSpanish } from 'state/actions/action-creators';
import getSpecialChars from 'state/static-data/get-special-chars';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Box from '@mui/material/Box';
import TrapFocus from '@mui/material/Unstable_TrapFocus';
import { makeStyles } from '@mui/styles';
import { translate } from 'translations/translator';
const tAria = key => translate('a11y', key);

const GRID_COLUMNS = 6;

const InsertSpanishPopup = ({ closePopup }) => {
  const specialCharacters = getSpecialChars();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { popup, container, header, closeButton, icon, charItem, charText, uppercase, lowercase } =
    classes;
  const lastRowStartIndex = (Math.ceil(specialCharacters.length / GRID_COLUMNS) - 1) * GRID_COLUMNS;

  const handleInsertSpanishClick = specialChar => {
    dispatch(insertSpanish(specialChar));
  };

  const handleAccessibilityMethodWrapper = onClick => {
    return event => {
      if (event.key === 'Enter' || event.key === ' ') {
        onClick();
      }
    };
  };

  return (
    <TrapFocus open isEnabled={() => true} getDoc={() => document}>
      <Box className={popup}>
        <Box className={header}>
          <Box
            className={closeButton}
            role="button"
            onClick={closePopup}
            tabIndex={0}
            aria-label={tAria('closeButton')}
            onKeyPress={event => handleAccessibilityMethodWrapper(closePopup)(event)}
          >
            <FontAwesomeIcon icon={faTimes} size={'2x'} className={icon} />
          </Box>
        </Box>
        <Box className={container}>
          {specialCharacters.map((item, index) => {
            const isLastColumn = (index + 1) % GRID_COLUMNS === 0;
            const isLastRow = index >= lastRowStartIndex;

            return (
              <Box
                className={charItem}
                key={index}
                role="button"
                // hide edges that would otherwise double up with the popover's border
                style={{
                  borderRight: isLastColumn ? 'none' : undefined,
                  borderBottom: isLastRow ? 'none' : undefined
                }}
              >
                <Box
                  className={`${charText} ${item.type === 'uppercase' ? uppercase : lowercase}`}
                  tabIndex={0}
                  onClick={() => handleInsertSpanishClick(item.char)}
                  onKeyPress={event =>
                    handleAccessibilityMethodWrapper(() => handleInsertSpanishClick(item.char))(
                      event
                    )
                  }
                  aria-label={item.name}
                >
                  {item.char}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </TrapFocus>
  );
};

export default InsertSpanishPopup;

const useStyles = makeStyles({
  popup: {
    // width fits exactly 6 charItem columns
    width: '246px',
    overflow: 'hidden'
  },
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(6, 41px)'
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderBottom: '1px solid #000000',
    backgroundColor: '#2e7bc2'
  },
  closeButton: {
    margin: '5px',
    marginRight: '10px'
  },
  icon: {
    cursor: 'pointer',
    color: '#ffffff'
  },
  charItem: {
    width: '41px',
    height: '41px',
    borderWidth: '0px 1px 1px 0px',
    borderStyle: 'solid',
    borderColor: 'black',
    margin: 0,
    color: 'black',
    textAlign: 'center',
    backgroundColor: 'white'
  },
  charText: {
    fontSize: '27px',
    fontFamily: 'Print-Wide-Light',
    width: '100%',
    height: '100%',
    verticalAlign: 'middle',
    display: 'inline-block',
    '&:hover': {
      border: '1px solid #ffff00'
    }
  },
  uppercase: {
    lineHeight: '53px'
  },
  lowercase: {
    lineHeight: '39px'
  }
});
